import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/ui-common/src/Dialog/Dialog.tsx";
var _excluded = ["children", "open", "BackdropComponent", "PaperComponent", "maxWidth", "fullWidth", "onClose", "scroll"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.timers.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Backdrop } from '../Backdrop';
import { Paper } from '../Paper';
import { DialogRoot, DialogWrapper, PaperWrapper } from './Dialog.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$BackdropComponen = _ref.BackdropComponent,
      BackdropComponent = _ref$BackdropComponen === void 0 ? Backdrop : _ref$BackdropComponen,
      _ref$PaperComponent = _ref.PaperComponent,
      PaperComponent = _ref$PaperComponent === void 0 ? Paper : _ref$PaperComponent,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 'sm' : _ref$maxWidth,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      onClose = _ref.onClose,
      _ref$scroll = _ref.scroll,
      scroll = _ref$scroll === void 0 ? 'paper' : _ref$scroll,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setIsMounted = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpenStylesApplied = _useState4[0],
      setIsOpenStylesApplied = _useState4[1];

  useEffect(function () {
    var onEscDown = function onEscDown(_ref2) {
      var code = _ref2.code;

      if (code === 'Escape' && onClose) {
        onClose();
      }
    };

    document.addEventListener('keydown', onEscDown);
    return function () {
      document.removeEventListener('keydown', onEscDown);
    };
  }, [onClose]);
  useEffect(function () {
    if (open) {
      setIsMounted(true); //чтобы реакт не собирал их в один вызов, для транзишена

      setTimeout(function () {
        return setIsOpenStylesApplied(true);
      }, 0);
    }

    if (!open) {
      setIsOpenStylesApplied(false);
      setTimeout(function () {
        return setIsMounted(false);
      }, 225);
    }
  }, [open]);
  return isMounted ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsxs(DialogRoot, _objectSpread(_objectSpread({
    role: "presentation"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(BackdropComponent, {
      open: isOpenStylesApplied,
      style: {
        opacity: isOpenStylesApplied ? 1 : 0,
        transition: isOpenStylesApplied ? 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      },
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogWrapper, {
      role: "none presentation",
      open: isOpenStylesApplied,
      style: {
        opacity: isOpenStylesApplied ? 1 : 0,
        transition: isOpenStylesApplied ? 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
      },
      scroll: scroll,
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(PaperWrapper, {
        PaperComponent: PaperComponent,
        scroll: scroll,
        maxWidth: maxWidth,
        fullWidth: fullWidth,
        children: children
      })
    })]
  })), document.body) : null;
};